import { ObjectHelpers } from "../../helpers/object-helpers";

export class LimitAlertImageModel {

    public xValue: number | null = null;
    public up = false;
    public tooltip = '';

    constructor(data?: any) {
        if (data) {
            this.cast(data);
        }
    }

    private cast(data: any) {
        ObjectHelpers.setProperties(data, this, true);
    }

    public getImage(basePath: string): string {
        if (this.up) {
            return basePath + 'assetfiles/img/bluearrowup.png';
        }

        return  basePath + 'assetfiles/img/bluearrowdown.png';
    }
}